import React, { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { SocialIcon, SocialLinks, SocialIconSvg, SvgClickableContainer } from '../../components/SocialMedia';
import { clickedShareInContent } from '../../provider/TrackingProvider/conversions/clickedShareInContent';
import { clickedShareInNav } from '../../provider/TrackingProvider/conversions/clickedShareInNav';
import { withTrackingApi, WithTrackingApiProps } from '../../provider/TrackingProvider/withTrackingApi';
import {
  selectMeta
} from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { SocialService } from '../../types/SocialService';

export interface SocialLinksContainerProps {
  type?: 'navi' | 'content';
  onCopiedToClipboard?: () => void;
}

class SocialLinksContainer extends Component<
  SocialLinksContainerProps & WithTypo3Props & WithTrackingApiProps & RouteComponentProps
  > {

  private trackShare = (service: SocialService) => {
    const { trackingApi, type } = this.props;

    if(type === 'navi') {
      trackingApi.trackEvents(clickedShareInNav(window.location.href, service));
    } else {
      trackingApi.trackEvents(clickedShareInContent(window.location.href, service));
    }
  };

  private sharePath = () => {
    const {location} = this.props;
    const {pathname, hash = '', search = ''} = location;
    const {protocol, host} = window.location;
    const path = `${protocol}//${host}${pathname}${search}${hash}`;

    return path;
  };

  private copyLink = async () => {
    try {
      await navigator.clipboard.writeText(this.sharePath());
      if(this.props.onCopiedToClipboard) {
        this.props.onCopiedToClipboard();
      }
    } catch (e) {}
  };

  public render = () => {
    const meta = selectMeta(this.props.typo3);

    if (!meta) {
      return null;
    }

    const {location} = this.props;
    const {pathname, hash = '', search = ''} = location;
    const {protocol, host} = window.location;
    const path = `${protocol}//${host}${pathname}${search}${hash}`;
    const encodedPath = encodeURIComponent(path);

    return <SocialLinks>
      <SocialIcon
        href={'mailto:?body=' + path}
        target="_blank"
        icon="mail"
        rel="noopener noreferrer nofollow"
        onClick={() => this.trackShare('mail')}
      />
      <SocialIcon
        href={`https://www.facebook.com/sharer.php?u=${encodedPath}`}
        target="_blank"
        icon="facebook"
        rel="noopener noreferrer nofollow"
        onClick={() => this.trackShare('facebook')}
      />
      <SocialIcon
        href={`https://twitter.com/share?url=${encodedPath}`}
        target="_blank"
        icon="twitter"
        rel="noopener noreferrer nofollow"
        onClick={() => this.trackShare('twitter')}
      />
      <SocialIcon
        href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodedPath}`}
        target="_blank"
        icon="linkedin"
        rel="noopener noreferrer nofollow"
        onClick={() => this.trackShare('linkedin')}
      />
      {this.props.type === 'navi' && (
        <SvgClickableContainer onClick={this.copyLink}>
          <SocialIconSvg
            target="_blank"
            icon="copy"
            rel="noopener noreferrer nofollow"
            onClick={this.copyLink}
          />
        </SvgClickableContainer>
      )}
    </SocialLinks>;
  }
}

export default withRouter(withTrackingApi(withTypo3(SocialLinksContainer)));
